import { recyclingScheduledServiceOtherWeekDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getRecyclingScheduledServiceOtherWeekEn = () => {
  const data = recyclingScheduledServiceOtherWeekDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addrecyclingScheduledServiceOtherWeek = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/what-is-my-recycling-schedule-if-im-serviced-every-other-week`,
    ) &&
    document.getElementById(`recyclingScheduledServiceOtherWeekJSONLD`) === null
  ) {
    const script = RecyclingScheduledServiceOtherWeekJSONLDEn()
    addJSONLDToHead(script, `recyclingScheduledServiceOtherWeekJSONLD`)
  } else {
    removeElement(`recyclingScheduledServiceOtherWeekJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const RecyclingScheduledServiceOtherWeekJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRecyclingScheduledServiceOtherWeekEn(),
  }
  return FaqBagsterTemplate
}
